// extracted by mini-css-extract-plugin
export default {"root":"SubscriptionsModal__root--3CAw4"};